import { useEffect, useState } from "react";
import TrackedApp from "../App";
import { eventEmitter } from "../event_emitter";
import "../global.css";
import { AuthFlowController } from "./AuthFlowController";
import { MSALProvider } from "./msalProvider";
import { OnboardingFlow } from "./OnboardingFlow";
import { usePopulateReduxStore } from "./usePopulateReduxStore";
import { msalAccount } from "./msalEventCallback";
import { useNorthPassSync } from "./useNorthPassSync";
import FullScreenLoadingMessage from "../design/high-level/fullscreen_loading_spinner";

export function AuthProvider() {
  // STATE
  const [showSignatoryView, setShowSignatoryView] = useState<boolean>(false);
  // msalAccount is a module variable, not React state: this flag is what re-renders the provider
  // once the token has landed and the API clients exist.
  const [apiReady, setApiReady] = useState<boolean>(false);

  useEffect(() => {
    function handleApiReady() {
      setApiReady(true);
    }

    eventEmitter.addEventListener("apiInitialized", handleApiReady);
    return () => {
      eventEmitter.removeEventListener("apiInitialized", handleApiReady);
    };
  }, []);

  // HOOKS
  const { reduxPopulated, userInactive, disable_flow } = usePopulateReduxStore(
    apiReady ? msalAccount : null,
    setShowSignatoryView,
  );

  // North Pass sync
  useNorthPassSync();

  return disable_flow ? (
    reduxPopulated ? (
      <TrackedApp />
    ) : (
      <FullScreenLoadingMessage message="Gathering info..." />
    )
  ) : (
    <MSALProvider>
        <AuthFlowController userInactive={userInactive}>
          <OnboardingFlow
            msalAccount={msalAccount}
            reduxPopulated={reduxPopulated}
            showSignatoryView={showSignatoryView}
            setShowSignatoryView={setShowSignatoryView}
          >
            <TrackedApp />
          </OnboardingFlow>
        </AuthFlowController>
    </MSALProvider>
  );
}
